import { createStore, createLogger } from 'vuex'
import users from 'store/modules/users'
import hotel from 'store/modules/hotel'
import prices from 'store/modules/prices'
import messages from 'store/modules/messages'
import supplements from 'store/modules/supplements'
import reservations from 'store/modules/reservations' 
import { useCookies } from "vue3-cookies";
import apiService from 'services/api.service';

const { cookies } = useCookies();
const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    state: {
        locale: 'en',
        loaderActive: false,
        darkMode: false,
        openSidebar: true,
        config: {}
    },
    mutations: {
        toggleSidebar(state, isOpen) {
            state.openSidebar = isOpen
            if (!isOpen) {
                document.getElementsByTagName('body')[0].classList.add('sidebar-closed');
                document.getElementsByTagName('body')[0].classList.add('sidebar-collapse');
                document.getElementsByTagName('body')[0].classList.remove('sidebar-open');
            } else {
                document.getElementsByTagName('body')[0].classList.remove('sidebar-collapse');
                document.getElementsByTagName('body')[0].classList.remove('sidebar-closed');
                document.getElementsByTagName('body')[0].classList.add('sidebar-open');
            }
        },
        setLocale(state, locale) {
            state.locale = locale
        },
        setDarkMode(state, status) {
            state.darkMode = status ? true : false
        },
        setLoader(state, active) {
            state.loaderActive = (active) ? true : false
        },
        setConfig(state, config) {
            state.config = config
        }
    },
    actions: {
        setDarkMode({ commit }, status) {
            commit('setDarkMode', status)
        },
        loadConfig({ commit }) {
            apiService.getFrApi({
                url: 'config/getConfig',
                method: 'get',
                locale: this.locale
            }).then(response => {
                cookies.set('config', response.data.data, '1h');
                commit('setConfig', response.data.data)
                console.log(response.data.data);
            })
        }
    },
    modules: {
        users,
        prices,
        messages,
        supplements,
        hotel,
        reservations
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
